<template>
  <table :id="`candidate-summary-item_${candidateId}`" class="candidate-summary-item" role="presentation" width="520" cellspacing="0" cellpadding="0" border="0" style="width: 520px; border-collapse: collapse; border-spacing: 0; table-layout: fixed; color: #474646; font-family: Inter, Arial, sans-serif;">
    <tbody>
      <tr>
        <td width="376" style="width: 376px; padding: 24px 0; font-size: 16px; line-height: 22px; mso-line-height-rule: exactly; word-break: break-word;">{{ candidateName }}</td>
        <td width="144" align="center" style="width: 144px; padding: 24px 0;">
          <table role="presentation" align="center" width="140" cellspacing="0" cellpadding="0" border="0" style="width: 140px; border-collapse: separate; border-spacing: 0; table-layout: fixed; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">
            <tbody>
              <tr>
                <td data-email-theme-color="true" align="center" :style="themeColorStyle">
                  <a data-email-theme-color="true" :href="rateLink" :style="themeLinkStyle">{{ isEnglish ? 'View Resume' : '查看简历' }}</a>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr v-if="showFitScore">
        <td colspan="2" style="padding: 0 0 16px;">
          <table :id="`candidate-ai-match-content_${candidateId}`" class="candidate-ai-match-content" role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="width: 100%; border-collapse: collapse; border-spacing: 0; border: 1px solid #dddddd;">
            <tbody>
              <tr>
                <td :id="`ai-match-title_${candidateId}`" style="padding: 12px; font-size: 16px; line-height: 28px; font-weight: 700; mso-line-height-rule: exactly;">{{ isEnglish ? 'AI Fit Score' : 'AI匹配度' }}</td>
                <td width="64" align="right" style="width: 64px; padding: 8px 12px;">
                  <button v-if="showGenerateFitScoreButton" :id="`generate-ai-match-btn_${candidateId}`" class="generate-ai-match-btn" contenteditable="false">{{ isEnglish ? 'Generate Fit Score' : '生成匹配度' }}</button>
                  <div :id="`ai-match-fit-score_${candidateId}`" class="chart-score" contenteditable="false" style="width: 28px; height: 28px;">
                    <img v-if="fitScoreImageUrl" :src="fitScoreImageUrl" class="ai-match-img" width="28" height="28" style="display: block; width: 28px; height: 28px; border: 0;">
                    <span v-else-if="fitScoreValue" style="display: inline-block; width: 28px; height: 28px; border: 1px solid #dcdfe6; font-size: 12px; line-height: 28px; text-align: center; mso-line-height-rule: exactly;">{{ fitScoreValue }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr v-if="showSummary">
        <td colspan="2" style="padding: 0 0 16px;">
          <table :id="`candidate-summary-content_${candidateId}`" class="candidate-summary-content" role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="width: 100%; border-collapse: collapse; border-spacing: 0; border: 1px solid #dddddd;">
            <tbody>
              <tr>
                <td :id="`ai-summary-title_${candidateId}`" style="padding: 12px 12px 8px; font-size: 16px; line-height: 22px; font-weight: 700; mso-line-height-rule: exactly;">{{ isEnglish ? 'AI Resume Summary' : 'AI简历提炼' }}</td>
              </tr>
              <tr>
                <td style="padding: 0 12px 12px; font-size: 14px; line-height: 20px; mso-line-height-rule: exactly; word-break: break-word;">
                  <span :id="`candidate_summary_${candidateId}`" style="white-space: pre-wrap;">{{ summary }}</span><span :id="`cursor_${candidateId}`" class="cursor" style="display: none;">|</span><button v-if="showGenerateSummaryButton" :id="`generate-ai-summary-btn_${candidateId}`" class="generate-ai-summary-btn" contenteditable="false">{{ isEnglish ? 'Summarize Resume' : 'AI简历提炼' }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr v-if="showLoading">
        <td colspan="2" style="padding: 0;">
          <div :id="`ai-summary-loading_${candidateId}`" class="ai-summary-loading rect-loading loading-mask" style="display: none;">
            <div class="loading-spinner">
              <div class="spinner">
                <div class="rect1" />
                <div class="rect2" />
                <div class="rect3" />
                <div class="rect4" />
                <div class="rect5" />
              </div>
            </div>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>

export default {
  props: {
    allowGenerateFitScore: {
      type: Boolean,
      required: true
    },
    allowGenerateSummary: {
      type: Boolean,
      required: true
    },
    candidateId: {
      type: [Number, String],
      required: true
    },
    candidateName: {
      type: String,
      default: ''
    },
    fitScoreImageUrl: {
      type: String,
      default: ''
    },
    fitScoreValue: {
      type: String,
      default: ''
    },
    languageCode: {
      type: String,
      required: true
    },
    rateLink: {
      type: String,
      default: ''
    },
    showFitScore: {
      type: Boolean,
      required: true
    },
    showLoading: {
      type: Boolean,
      required: true
    },
    showSummary: {
      type: Boolean,
      required: true
    },
    summary: {
      type: String,
      default: ''
    },
    themeColor: {
      type: String,
      required: true
    }
  },
  computed: {
    isEnglish () {
      return this.languageCode === 'en'
    },
    showGenerateFitScoreButton () {
      return this.allowGenerateFitScore && !this.fitScoreImageUrl && !this.fitScoreValue
    },
    showGenerateSummaryButton () {
      return this.allowGenerateSummary && !this.summary
    },
    themeColorStyle () {
      return `border: 1px solid ${this.themeColor}; color: ${this.themeColor}; padding: 6px 8px; font-size: 14px; line-height: 18px; font-weight: 700; mso-line-height-rule: exactly; white-space: nowrap;`
    },
    themeLinkStyle () {
      return `display: block; color: ${this.themeColor}; font-family: Inter, Arial, sans-serif; font-size: 14px; line-height: 18px; font-weight: 700; mso-line-height-rule: exactly; text-decoration: none; white-space: nowrap;`
    }
  }
}
</script>
